<template>
  <v-col cols="12" md="3" sm="3">
    <div class="card-resume rounded-lg" @click="openLoading(evento)">
      <v-img
        :src="evento.imagens.destaque || evento.imagens.imagem1"
        class="white--text align-end rounded-lg"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.5)"
        height="130px"
      >
        <v-card-title
          class="font-weight-bold title-style justify-start"
          :class="{ 'title-style-mobile': !mdAndUp }"
        >
          {{ evento.descricao | cutText(32) }}
        </v-card-title>
        <v-card-subtitle
          class="font-weight-bold justify-center"
          :class="{ 'mr-0': !mdAndUp }"
        >
          <v-icon :size="iconSize" color="#fff">mdi-calendar</v-icon>
          {{ formatDate(evento.dt_apresentacao) }}
          <v-icon :size="iconSize" color="#fff">mdi-clock</v-icon>
          {{ formatHour(evento.hr_apresentacao) }}
        </v-card-subtitle>
      </v-img>
      <v-expand-transition>
        <v-card-text class="rounded-lg" max-height="70">
          <v-row>
            <v-col class="pt-1">
              <p class="text-body-3">
                <v-icon> mdi-finance </v-icon>
                Ingressos Vendidos: <b>{{ evento.qt_vendida }}</b>
              </p>
              <p class="text-body-3">
                <v-icon>mdi-cash</v-icon>
                Faturamento Total: <b>{{ valueSold }}</b>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
      <v-chip v-if="closed" color="error" pill x-small class="combo-status">
        {{ "Encerrado" }}
      </v-chip>
      <v-chip v-else color="success" pill x-small class="combo-status">
        {{ "Ativo" }}
      </v-chip>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { formatDate, formatHour } from "@/utils";

export default {
  name: "ResumeCard",
  mixins: [displayHelpers],
  props: {
    evento: {
      type: Object,
      required: true,
    },
    closed: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      resumeLoading: false,
      formatDate,
      formatHour,
    };
  },
  computed: {
    ...mapGetters(["dashEventLoading", "dashEvent", "showDetails"]),
    totalInvoincing() {
      if (Math.sign(this.dashEvent.faturamento_total) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "positive-percent",
        };
      }
    },
    valueSold() {
      const valorVendido = Number.parseFloat(
        this.evento.valor_vendido.replace(",", "")
      );
      const formattedValue = Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valorVendido);
      return formattedValue;
    },
    imageSize() {
      return this.mdAndUp ? 80 : 70;
    },
    titleSize() {
      return this.mdAndUp ? "subtitle-1" : "body-2";
    },
    subtitleSize() {
      return this.mdAndUp ? "body-2" : "caption";
    },
    iconSize() {
      return this.mdAndUp ? "18px" : "18px";
    },
    paddingSize() {
      return this.mdAndUp ? "pa-6" : "pa-4";
    },
  },
  methods: {
    ...mapActions(["setDashEvent", "setDashCheckin", "setSalesByTicketDash"]),
    async openLoading(item) {
      try {
        // eslint-disable-next-line no-prototype-builtins
        if (!item.hasOwnProperty("loading_dash")) {
          this.$set(item, "loading_dash", false);
        }

        item.loading_dash = true;
        await this.setDashEvent(item);
      } finally {
        item.loading_dash = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title-style {
  max-width: 25ch !important;
  font-size: 14px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.title-style-mobile {
  max-width: 25ch !important;
  font-size: 14px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.card-resume {
  position: relative;
  cursor: pointer;
  max-height: 200px;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, 11px 11px 22px #ffffff;
  transition: all 0.2s ease-in-out;
}

.card-resume:hover {
  transform: scale(1.05);
  box-shadow: 11px 11px 12px #d9d9d9, 11px 11px 22px #ffffff;
}
.combo-status {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}

.overlay-add {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

@media (max-width: 600px) {
  .title-style {
    max-width: 25ch !important;
  }
}
</style>
